import React, { useEffect } from 'react';
import { Container } from '@mui/material';
import { makeStyles } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux';
import Page from 'src/components/Page';
import Header from './Header';
import TestimonialForm from '../TestimonialCreate/TestimonialForm';

import MperitoCard from 'src/components/MperitoCard';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingTop: theme.spacing(3),
        paddingBottom: 100
    }
}));

function TestimonialEdit() {
    const classes = useStyles();
    const {state} = useLocation();

    const businessInfo = useSelector((state) => state?.app?.businessInfo);
    const customerId = businessInfo?.customerId;

    useEffect(() => {

    }, [businessInfo]);

    return (
        <Page
            className={classes.root}
            title="Testimonial Update"
        >
            <Container maxWidth={false}>
                <Header />
                <MperitoCard title={`Update Testimonial ( ${businessInfo?.businessName} - ${businessInfo?.customerId} )`}>
                    <TestimonialForm data={state} customerId={customerId} />
                </MperitoCard>
            </Container>
        </Page>
    );
}

export default TestimonialEdit;